import { FC, Fragment, useEffect } from 'react';
import { DashboardLayout } from 'Components';
import { CreditCardList } from './CreditCardList';
import { NoCard } from './NoCreditCard';
import { useBinListManager } from 'Hooks';
import {
  CreditCardTransactionsState,
  creditCardTransactionsStore,
  onGetMasterpassTokenRequest,
} from 'Stores/CreditCardTransactions';
import { useDispatch, useSelector } from 'react-redux';
import { UserState, userStore } from 'Stores/User';
import { MasterPassAccountStatusEnum, MasterpassServicess, MasterPassTokenEnum } from 'Utils';
import { masterPassListCardNormalize, masterPassRegisterNormalize } from 'Normalize';

import './CreditCard.scss';
import { useHistory } from 'react-router-dom';
import { routePath } from 'Navigator/routes';
import { MasterpassConnect } from 'Views/MasterpassConnect';
import { masterPassLinkToClientNormalize } from 'Normalize/MasterPassRequestNormalize';

const CreditCard: FC = () => {
  const { creditCardList, loading } = useSelector(creditCardTransactionsStore);

  const dispatch = useDispatch();
  const history = useHistory();

  const userData: UserState = useSelector(userStore);
  const cardData: CreditCardTransactionsState = useSelector(creditCardTransactionsStore);

  const customerNumber = userData?.customerNumber;
  const sessionToken = userData?.sessionToken;
  const accountStatus = cardData?.masterPassAccountStatus;

  // BIN listesi yönetimi için hook kullan
  useBinListManager(creditCardList);

  /**
   * Kayıtlı kart listesi — her açılışta SUNUCUDAN TAZE çekilir.
   *
   * ⚠️ `forceRefresh` ZORUNLU, kaldırmayın. Saga, bellekte dolu bir liste varken
   * kart listesi isteklerini kısa devre yapıyor (gereksiz Masterpass turlarını
   * önlemek için). Bu ekranda o davranış yanlış sonuç veriyor, çünkü listenin
   * kendisi ekranın İÇERİĞİ ve kart ekleme/silme sonrası mutlaka değişmiş oluyor.
   *
   * Somut hata: kart eklendikten (ya da silindikten) sonra saga zorunlu bir
   * tazeleme dispatch edip hemen ardından `goBack()` ile bu ekrana dönüyor.
   * Ekran mount olup KENDİ isteğini atıyor; watcher `takeLatest` kullandığı için
   * bu ikinci istek, henüz tamamlanmamış zorunlu tazelemeyi İPTAL EDİYOR. İkinci
   * istek `forceRefresh` taşımadığında bayat ama dolu listeyi görüp kısa devre
   * yapıyor ve hiç istek atılmıyordu — eklenen kart görünmüyor, silinen kart
   * ekranda kalıyordu.
   *
   * Buraya `forceRefresh` konunca yarışın kimin kazandığı önemsizleşiyor:
   * hangi istek hayatta kalırsa kalsın sunucuya gidiliyor.
   */
  useEffect(() => {
    dispatch(
      onGetMasterpassTokenRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        TokenType: MasterPassTokenEnum.CARD_LIST,
        forceRefresh: true,
        request: {
          data: masterPassListCardNormalize(),
        },
      })
    );
  }, []);

  return (
    <DashboardLayout backButton>
      <Fragment>
        {accountStatus === MasterPassAccountStatusEnum.NO_LINKED ? (
          <MasterpassConnect />
        ) : (
          !loading && (
            <div id="credit-card">
              {creditCardList && creditCardList.length !== 0 ? (
                <CreditCardList data={creditCardList} />
              ) : (
                !loading && <NoCard />
              )}
            </div>
          )
        )}
      </Fragment>
    </DashboardLayout>
  );
};

export default CreditCard;
